
export type LogMode =
    "None"
    | "Operations"
    | "Information";
